import StyleGuideContainer from '../components/StyleGuideContainer/StyleGuideContainer.vue';

export default {
    path: '/styleguide',
    component: StyleGuideContainer
};



// WEBPACK FOOTER //
// ./src/routes/routes-page.js